import React from "react";
import "./NotFound.scss";

function NotFoundPage() {
  return (
    <section className="notFound">
      <div className="notFound-content">
        <h1 className="notFound-content__header">Sorry.</h1>
        <p className="notFound-content__txt">
          This page is currently unavailable for viewing. Please feel free to
          explore my other projects and recent activities.
        </p>
        {/* <div className="notFound-content__options">
          <button class="notFound-content__options__github">github</button>
          <button class="notFound-content__medium">medium</button>
          <button class="notFound-content__linkedin">linkedin</button>
        </div> */}
      </div>
    </section>
  );
}

export default NotFoundPage;
